import script from "./TemplatesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&setup=true&lang=js"

import "./TemplatesTable.vue?vue&type=style&index=0&id=35def243&scoped=true&lang=css"
script.__scopeId = "data-v-35def243"

export default script